import React from 'react';
import { WorkflowContext } from '../../../__generated__/graphql';
import { routes as mainRoutes } from '../../../routes';
import { Workflows } from './Workflows';

export const WorkflowsForAll: React.FC = () => {
  return (
    <Workflows
      workflowContext={WorkflowContext.All}
      route={mainRoutes.workflowsAllWorkflows.route}
      itemRoute={mainRoutes.workflowsAllWorkflowItems.route}
    />
  );
};
